<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row>
								<v-col class="pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">
										{{ $t('titles.teacherActivities') }}</v-card-title
									>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="teacherActivitiesTable.additionalFilters"
										:default-sort="teacherActivitiesTable.defaultSort"
										:excel="false"
										:fields="teacherActivitiesTable.headers"
										:header-selection-key="'teacher-activities-headers'"
										:height="teacherActivitiesTable.height"
										:total-records="teacherActivitiesTable.total"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in teacherActivitiesTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
										>
											<td v-if="teacherActivitiesTable.selectedHeaders.includes('date')">
												{{ item.date != null ? item.date.split('-').reverse().join('.') : '' }}
											</td>
											<td v-if="teacherActivitiesTable.selectedHeaders.includes('hours')">
												{{ item.hours }}
											</td>
											<td v-if="teacherActivitiesTable.selectedHeaders.includes('course')">
												{{
													item.planned_course.course.code +
													' ' +
													item.planned_course.course.name +
													' - ' +
													item.planned_course.office.name +
													' - ' +
													item.planned_course.start_date.split('-').reverse().join('.')
												}}
											</td>
											<td
												v-if="teacherActivitiesTable.selectedHeaders.includes('hour_rate_type')"
											>
												{{ item.hour_rate_type }}
											</td>
											<td v-if="teacherActivitiesTable.selectedHeaders.includes('hour_rate')">
												{{ item.hour_rate }}
											</td>
											<td
												style="text-align: right"
												v-if="teacherActivitiesTable.selectedHeaders.includes('amount')"
											>
												{{
													Number((item.hour_rate * item.hours).toFixed(2)).toLocaleString(
														'hr'
													)
												}}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'TeacherActivities',
	components: { TheTable },
	props: {
		teacherId: [String, Number],
	},
	data: function () {
		return {
			teacherActivitiesTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.date'), value: 'date', type: '', allowFilter: true },
					{ text: this.$t('fields.hours'), value: 'hours', type: '', allowFilter: true },
					{
						text: this.$t('fields.course'),
						value: 'course',
						type: 'dropdown|planned-courses',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.hourRateType'),
						value: 'hour_rate_type',
						type: 'string',
						allowFilter: true,
					},
					{ text: this.$t('fields.hourRate'), value: 'hour_rate', type: '', allowFilter: true },
					{
						text: this.$t('fields.amount'),
						value: 'amount',
						type: '',
						sortable: false,
						allowFilter: true,
						alignRight: true,
					},
				],
				additionalFilters: [
					{ text: this.$t('fields.hours'), value: 'hours', type: 'price_range' },
					{ text: this.$t('fields.hourRate'), value: 'hour_rate', type: 'price_range' },
					{
						text: this.$t('fields.date'),
						value: 'date',
						type: 'date_range',
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
		};
	},
	methods: {
		selectHeaders(headers) {
			this.teacherActivitiesTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.teacherActivitiesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'teachers-activities/' + this.teacherId,
				request,
				(data, success) => {
					if (success) {
						vm.teacherActivitiesTable.items = data.items;
						vm.teacherActivitiesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.teacherActivitiesTable.height = window.innerHeight - 310 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
